<template>
    <div class="pay-page" v-loading="loading">
        <el-row :gutter="20">
            <el-col v-if="cards.length > 1" :span="24">
                <el-card class="m-b-20">
                    <div slot="header">
                        <h2>Оплата парковки</h2>
                    </div>

                    <div class="color-gray">
                        <small>По карте</small>
                    </div>
                    <el-select :clearable="true" v-model="cardId" placeholder="Выберите карту" class="w-100" filterable>
                        <el-option
                            v-for="item in cards"
                            :key="item.ID"
                            :label="item.Name"
                            :value="item.ID">
                        </el-option>
                    </el-select>

                    <div class="m-t-20 color-gray">
                        <small>По автомобилю</small>
                    </div>
                    <el-select :clearable="true" v-model="cardId" placeholder="Выберите автомобиль" class="w-100" filterable>
                        <el-option
                            v-for="item in cars"
                            :key="item.CardID"
                            :label="item.Model"
                            :value="item.CardID">
                        </el-option>
                    </el-select>

                    <!--                <el-input v-model="cardId"></el-input>-->

                    <el-button class="m-t-20" icon="icon-search" type="primary" @click="searchCard">
                        Получить данные по оплате
                    </el-button>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col v-if="cardId && (params || message)" :span="24">
                <el-card class="min-height-220">
                    <div slot="header" class="d-flex flex-header">
                        <el-row :gutter="0" class="w-100">
                            <el-col :xs="24" :sm="24" :md="12">
                                <h2>Карта №{{ (cardId && cards.find(x => x.ID === cardId) ? cards.find(x => x.ID === cardId).Name : '') }}</h2>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" align="right">
                                <el-button v-if="!message" type="primary" @click="pay">Оплатить</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <h2 class="m-b-20" v-if="message" v-html="message" />
                    <div v-if="paramsDict" class="params">
                        <!-- eslint-disable-next-line -->
                        <div v-if="paramsDict[key]" v-for="(param, key) in params" :key="key">
                            <div>
                                <span>{{paramsDict[key]}}:</span>

                                <div v-if="key === 'Total'">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                </div>
                                <div v-else-if="!isNaN(param)">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                </div>
                                <div v-else-if="key === 'TimeExpirationCurrent'
                            || key === 'TimeExpirationAfterProlongation'
                            || key === 'LastPaymentTime'
                            || key === 'TimeExitBeforeAfterPayment'
                            || key === 'TimeEntry'
                            || key === 'TimeExitBeforeCurrent'
                            ">
                                    {{ param | date}}
                                </div>
                                <div v-else>
                                    {{param}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            cardId: (this.$route.query.cardId ? this.$route.query.cardId : ''),
            params: '',
            order: {
                amount: 0.00,
                currency: 'RUB',
                order_number: '',
                description: 'Оплата по договору парковки'
            },
            paramsDict: {},
            cards: [],
            cars: [],
            loadingCards: false,
            message: ''
        }
    },
    created () {
        this.getCards()
        this.getCars()
        if (this.$route.query.cardId) {
            this.searchCard()
        }
    },
    methods: {
        pay () {
            // eslint-disable-next-line no-undef
            ipayCheckout(this.order, this.successPurchase, this.failedPurchase)
        },
        successPurchase () {
            let body = {
                "Name": "RegisterPayment",
                "PaymentId": this.params.PaymentId,
                "PaymentCard": this.cardId,
                "ParkingCostResult": this.params
            }

            this.$api.Pay.registerPayment(body).then(response => {
                if (response.Result !== 'Failed') {
                    this.$message({ message: 'Оплата успешно зарегистрирована', type: 'success' })
                    this.message = 'Оплата успешно зарегистрирована'
                    this.searchCard()
                }
                else {
                    let body = {
                        "Name": "RevertPayment",
                        "orderId": this.params.PaymentId,
                        "Hash": this.token
                    }
                    this.$api.Pay.reversePayment(body).then(response => {
                        console.log(response)
                        this.$message({ message: 'Ошибка регистрации оплаты. Свяжитесь с технической поддержкой.', type: 'error' })
                        this.searchCard()
                    })
                }
            })
        },
        failedPurchase () {
            this.$message({ message: 'Ошибка оплаты', type: 'error' })
            this.searchCard()
        },
        searchCard () {
            if (!this.cardId) {
                this.$message({ message: 'Выберите карту для оплаты', type: 'error' })
                return
            }

            this.loading = true

            let body = {
                Name: 'GetParkingCost',
                ItemId: this.cardId,
                ItemProperties: [{
                    ItemPropertyName: 'cardId',
                    ItemPropertyValue: this.cardId
                }]
            }

            this.$api.Pay.getParkingCost(body).then(response => {
                if (response.Result !== 'Failed') {
                    this.order.amount = response.Total / 100
                    this.order.order_number = response.PaymentId

                    this.params = response
                    this.message = ''
                    this.paramsDict = {}

                    switch (response.Type) {
                        case 0:
                            this.message = 'Парковка не принимает оплаты в личном кабинете, воспользуйтесь кассовым терминалом'
                            break
                        case 1:
                            this.message = 'Оплата не требуется. Бесплатный тариф'
                            break
                        case 2:
                            this.paramsDict = {
                                Total: 'К оплате',
                                TimeExitBeforeAfterPayment: 'После приема оплаты выезд до',
                                TimeEntry: 'Въезд',
                                LastPaymentTime: 'Последняя оплата',
                                Paid: 'Сумма предыдущих оплат',
                                Debt: 'Задолженность за стоянки в других зонах',
                                Discount: 'Сумма скидок',
                            }
                            break
                        case 3:
                            this.paramsDict = {
                                Total: 'К оплате',
                                TimeExpirationCurrent: 'Срок действия абонемента до продления',
                                TimeExpirationAfterProlongation: 'Срок действия абонемента после продления',
                            }
                            break
                        case 4:
                            this.message = 'Произошла ошибка, обратитесь в администрацию парковки'
                            break
                        case 5:
                            this.message = 'Оплата не требуется'
                            this.paramsDict = {
                                TimeExitBeforeCurrent: 'Выезд до'
                            }
                            break
                        default:
                            break
                    }
                    this.loading = false
                }
                else {
                    console.log(response)
                    this.$message({ message: 'Ошибка получения данных карты', type: 'error' })
                    this.message = 'Ошибка получения данных карты'
                    this.params = ''
                    this.loading = false
                }
            }).catch ((err) => {
                this.$message({ message: 'Ошибка получения данных карты', type: 'error' })
                this.message = 'Ошибка получения данных карты <div><small>' + err.ErrorString + '</small>'
                this.params = ''
                this.loading = false
            })
        },
        getCards () {
            this.loadingCards = true

            let request = Object.assign({
                Name: "GetItemsList",
                ItemType: "Card",
                Filter: {
                    Type: "Simple",
                    Field: "CustomerID",
                    Operation: "Equal",
                    Value: parseInt(sessionStorage.getItem('customerId'))
                }
            }, this.form)

            this.$api.Main.getCards(request).then(response => {
                this.loadingCards = false
                this.cards = response.Items

                if (this.cards.length === 1) {
                    this.cardId = this.cards[0].ID
                    this.searchCard()
                }
            }).catch (() => {
                this.loadingCards = false
            })
        },
        getCars () {
            this.loadingCars = true

            let request = Object.assign({
                Name: "GetItemsList",
                ItemType: "Car"
            }, this.form)

            this.$api.Main.getCars(request).then(response => {
                this.loadingCars = false
                this.cars = response.Items
            }).catch (() => {
                this.loadingCars = false
            })
        },
    }
}

</script>

<style scoped>

</style>
